import { MessageDlg } from "./message-dlg";

export default class Utility {

    static getDateString(date) {
        var retDate = null;
        if (date.search("00:00:00") < 0) {
            retDate = new Date(`${date}  00:00:00`);
        } else {
            retDate = new Date(date);
        }

        if (
            retDate.getMonth() === 0 &&
            retDate.getDate() === 1 &&
            retDate.getFullYear() === 1970
        ) {
            return "";
        }

        return `${retDate.getMonth() + 1
            }/${retDate.getDate()}/${retDate.getFullYear()}`;
    }

    static getControlDate(date) {
        if (date) {
            var issueDate = new Date(date);
            var issueMonth = issueDate.getMonth() + 1;
            return `${issueDate.getFullYear()}-${issueMonth < 10 ? "0" : ""
                }${issueMonth}-${issueDate.getDate() < 10 ? "0" : ""
                }${issueDate.getDate()}`;
        }

        return null;
    }

    static getControlMonthYear(date) {
        if (date) {
            var issueDate = new Date(date);
            var issueMonth = issueDate.getMonth() + 1;
            return `${issueDate.getFullYear()}-${issueMonth < 10 ? "0" : ""
                }${issueMonth}`;
        }

        return null;
    }

    static getListValue(obj, value) {
        var type = obj.find((element) => {
            if (element.id === parseInt(value)) {
                return true;
            }

            return false;
        });

        if (type) {
            return { id: type.id, name: type.name };
        }

        return {};
    }

    static getYearListForDropdown(){
        var yearSelect = [];
        var curDate = new Date();
        for(var idx = 0; idx <= 60; ++idx ){
            yearSelect.push({id: idx, name: `${curDate.getFullYear() - idx}`});
        }

        return yearSelect;
    }

    static ShowMessageDlg() {
        const prompt = async () => {
            await MessageDlg(
                "Uh oh! We were unable to save your changes. Please try again later."
            );
        };

        prompt();
    }

    static loadNewTabImage(contentType, fileData, fileName,){
        let fileString = this.appendContentType(contentType, fileData);

        let w = window.open('_blank');
        
        if (contentType === 'application/pdf'){
            let html = '';
            html = `<html><head><title>${fileName}</title></head><body style="margin:0!important"><embed width="100%" height="100%" src="${fileString}" type="application/pdf" /></body></html>`;
            w.document.write(html);
        }
        else{
            let image = new Image();
            image.src = fileString;
            w.document.write(`<head><title>${fileName}</title></head>` + image.outerHTML);
        }   
    }

    static appendContentType(contentType, dataString){
        if (contentType === 'image/png'){
            return 'data:image/png;base64,' + dataString;
        }
        
        if (contentType === 'image/jpeg') {
            return 'data:image/jpeg;base64,' + dataString;
        }
        
        if (contentType === 'image/jpg'){
            return 'data:image/jpg;base64,' + dataString;
        }

        if (contentType === 'application/pdf'){
            return 'data:application/pdf;base64,'  + dataString;
        }
    }

    // Expects string in format: 'YYYY-MM-DD 00:00:00'. Excluding 00 time can cause incorrect date when converting to new string
    // i.e. '2021-02-01' becomes 02/01/2021, vs '2021-02-01 00:00:00' becomes 02/01/2021
    static formatDate(dateString) {
        // step one, format dateString from - to / (resolves UTC -> local issue)
        /* getMonth is 0 based, getDate is 1 based.
            for both:
                padStart(2,0), add '0' to start of string.
                slice(-2), grab last 2 digits. This way, we do not inappropriately pad double digit dates and months
                ex: days 1-9 become: 01-09. 
                    days 11-31 become 011-031 Slice(-2) -> 11-31
        */
        if (dateString) {
            if (!dateString.endsWith("00:00:00")) {
                dateString += " 00:00:00";
            }
            let date = new Date(dateString.toString());
            const day = date.getDate().toString().padStart(2, '0'); // Get day (1-31) and pad with zero if needed
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Get month (0-11) and pad with zero if needed
            const year = date.getFullYear().toString(); // Get full year (YYYY)

            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return '';
    }
}
